import type { Translate } from '@shared/hooks/locale';

type TransactionPreviewRooms = {
  number_of_bedrooms?: number | null;
  number_of_rooms?: number | null;
};

export const formatTransactionPreviewRooms = (
  property: TransactionPreviewRooms | null | undefined,
  locale: string,
  t: Translate,
): string => {
  if (property == null) {
    return '';
  }

  const country = locale.toLowerCase().split('-')[1];
  if (country === 'es' && property.number_of_bedrooms) {
    return ` • ${t('{{count}} bedroom', {
      count: property.number_of_bedrooms,
    })}`;
  }

  return property.number_of_rooms
    ? ` • ${t('{{count}} room', { count: property.number_of_rooms })}`
    : '';
};
